export default __webpack_public_path__ + "static/media/receipt_logo.ebd75e37.png";